import { render, staticRenderFns } from "./medical_record_new.vue?vue&type=template&id=188ed654&scoped=true&"
import script from "./medical_record_new.vue?vue&type=script&lang=js&"
export * from "./medical_record_new.vue?vue&type=script&lang=js&"
import style0 from "./medical_record_new.vue?vue&type=style&index=0&id=188ed654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ed654",
  null
  
)

component.options.__file = "medical_record_new.vue"
export default component.exports